// extracted by mini-css-extract-plugin
export var textArea = "TextArea-module--textArea--b7d59";